import { render } from "./SettingProduct.vue?vue&type=template&id=0fecca29&scoped=true"
import script from "./SettingProduct.vue?vue&type=script&lang=js"
export * from "./SettingProduct.vue?vue&type=script&lang=js"

import "./SettingProduct.vue?vue&type=style&index=0&id=0fecca29&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fecca29"]])

export default __exports__